import { render, staticRenderFns } from "./ModifierSection.vue?vue&type=template&id=18748cba"
import script from "./ModifierSection.vue?vue&type=script&lang=js"
export * from "./ModifierSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports